import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AssistantInfo } from "../../../services/api/instances/assistantsApi/types";
import type { StylistValue } from "../../../services/api/instances/stylistApi/stylistTypes";
import type { StylistMode } from "../Components/StylistMain/types";
import {
  createStylistReducerBuilder,
  deleteStylistReducerBuilder,
  getAllStylistsReducerBuilder,
  getAssistantsReducerBuilder,
  getStylistMessagesReducerBuilder,
  getStylistThreadReducerBuilder,
  postStylistMessageReducerBuilder,
} from "./reducers";
import type { StylistState } from "./types";
import { StorageObject } from "../../../services/api/instances/storageApi/types/object_types";

const initialState: StylistState = {
  assistants: [],
  selectedAssistant: null,
  thread: null,
  stylists: [],
  selectedStylist: null,
  dateUpdate: "",
  messages: [],
  stylistMode: "вручную",
  isResultLoading: false,
  isLoading: false,
};

const stylistSlice = createSlice({
  name: "stylist",
  initialState,
  reducers: {
    setSelectedAssistantAction: (
      state,
      action: PayloadAction<AssistantInfo>,
    ) => {
      state.selectedAssistant = action.payload;
    },

    setSelectedStylistAction: (
      state,
      action: PayloadAction<StorageObject<StylistValue> | null>,
    ) => {
      state.selectedStylist = action.payload;
    },
    setStylistAction: (
      state,
      action: PayloadAction<StorageObject<StylistValue>[]>,
    ) => {
      state.stylists = action.payload;
    },

    setStylistMode: (state, action: PayloadAction<StylistMode>) => {
      state.stylistMode = action.payload;
    },

    setStylistDateUpdate: (state, action: PayloadAction<string>) => {
      state.dateUpdate = action.payload;
    },

    setStylistLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStylistResultLoading: (state, action: PayloadAction<boolean>) => {
      state.isResultLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    getAllStylistsReducerBuilder(builder);
    createStylistReducerBuilder(builder);
    deleteStylistReducerBuilder(builder);
    getAssistantsReducerBuilder(builder);
    getStylistThreadReducerBuilder(builder);
    postStylistMessageReducerBuilder(builder);
    getStylistMessagesReducerBuilder(builder);
  },
});

export const stylistReducer = stylistSlice.reducer;
export const {
  setSelectedStylistAction,
  setStylistAction,
  setSelectedAssistantAction,
  setStylistMode,
  setStylistDateUpdate,
  setStylistLoading,
  setStylistResultLoading,
} = stylistSlice.actions;
